import InlineIcon from "./InlineIcon.jsx";

export default function Panel({ title, icon = "activity", right, children, className = "" }) {
  return (
    <section className={`dashboard-panel p-4 md:p-5 ${className}`}>
      <div className="mb-4 flex flex-wrap items-center justify-between gap-3">
        <h2 className="flex items-center gap-2 text-base font-semibold text-white">
          <InlineIcon name={icon} className="h-4 w-4 text-goldSoft" />
          {title}
        </h2>
        {right}
      </div>
      {children}
    </section>
  );
}
